"use client";

import { SWRConfig } from "swr";
import { localStorageSWRCacheProvider } from "@/lib/localStorageSWRCacheProvider";

interface SWRProviderProps {
  children: React.ReactNode;
}

/**
 * Global SWR configuration provider
 * Enables localStorage-backed cache persistence across page reloads
 */
export function SWRProvider({ children }: SWRProviderProps) {
  return (
    <SWRConfig
      value={{
        provider: localStorageSWRCacheProvider,
        // Global SWR options (can be overridden per-hook)
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
      }}
    >
      {children}
    </SWRConfig>
  );
}
